<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '90px' } }">
        <a-row>
          <a-col :md="7" :sm="24">
            <a-form-item label="加工组织" class="code-select" :help="null">
              <global-select
                selectType="selectAssemble"
                :default-active-first-option="true"
                requestApi="/system/user/inventOrgList"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :dropdown-match-select-width="false"
                v-decorator="['inventOrgValue', { rules: [{ required: true }], initialValue: inventOrg.length > 0 && inventOrg[0].realValue }]"
                :assembleLabel="true"
                @change="inventOrgValueOnChange"
              />
            </a-form-item>
          </a-col>
          <a-col :md="10" :sm="24">
            <a-form-item label="工艺路线" class="itemcode" :help="null">
              <a-select show-search option-filter-prop="children" v-decorator="['routingId', { rules: [{ required: true }] }]" @change="routingIdOnChange">
                <a-select-option v-for="(item) in routingList" :key="item.id">{{ item.routingCode }}</a-select-option>
              </a-select>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a-input v-decorator="['routingDesc']" class="ml10" disabled />
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a-button @click="$refs.createModal.show('add')" type="primary" class="ml8" v-hasPermi="['bom:bomRoutingHeader:add']">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiBomRoutingHeaderNewExport" ref="download" />
      <a-button @click="$refs.createModal.show('edit', tableData)" type="primary" :disabled="tableLoading" v-hasPermi="['bom:bomRoutingHeader:edit']">编辑</a-button>
      <a-button @click="importExcelHandleOpen" type="primary" v-hasPermi="['bom:bomRoutingHeader:import']">导入</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['bom:bomRoutingHeader:export']">导出</a-button>
      <a-button @click="importTemplate" v-hasPermi="['bom:bomRoutingHeader:template']">下载模板</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <a-table
          ref="table"
          :columns="columns"
          :loading="tableLoading"
          :data-source="tableList"
          :pagination="false"
          row-key="id"
        >
          <template slot="operationType" slot-scope="text, record">
            <span>{{ $lookupMeaning(operationTypeList, record.operationType) }}</span>
          </template>
        </a-table>
        <standard-process-edit
          ref="createModal"
          :inventOrg="inventOrg"
          @handle-success="handleOk"
        />
      </div>
      <!-- 上传文件 -->
      <a-modal
        :title="upload.title"
        :visible="excelVisible"
        @ok="importExcelHandleCancel"
        @cancel="importExcelHandleCancel"
      >
        <a-upload-dragger
          name="file"
          accept=".xlsx, .xls"
          :multiple="true"
          :headers="upload.headers"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          @change="importExcelHandleChange"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-text">
            请将文件拖拽到此处上传
          </p>
          <p class="ant-upload-hint">
            支持单个或批量上传，也可以点击后选择文件上传
          </p>
        </a-upload-dragger>
      </a-modal>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiBomRoutingHeaderId, apiBomRoutingHeaderFindList, apiBomRoutingHeaderNewExport } from '@/api/mes/basedata/standardProcess'
import StandardProcessEdit from './components/standard-process-edit'
import Cookies from 'js-cookie';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  name: 'StandardProcess',
  components: {
    DownloadModal,
    StandardProcessEdit
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiBomRoutingHeaderNewExport,
      operationTypeList: [], // 工序类型
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/bom/bomRoutingHeader/import'
      },
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      tableData: null,
      tableLoading: false,
      // 表格字段
      columns: [
        {
          title: '工序号',
          dataIndex: 'operationSeqNum',
          align: 'center'
        },
        {
          title: '工序编码',
          dataIndex: 'operationCode',
          align: 'center'
        },
        {
          title: '工序说明',
          dataIndex: 'operationDesc',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '工序类型',
          scopedSlots: { customRender: 'operationType' },
          dataIndex: 'operationType',
          align: 'center'
        },
        {
          title: '工时(分钟/套)',
          dataIndex: 'workingHours',
          width: 140,
          align: 'center'
        },
        {
          title: '配置人数',
          dataIndex: 'personnelAllocation',
          align: 'center'
        },
        // {
        //   title: '产能类型',
        //   dataIndex: 'capacityType',
        //   align: 'center'
        // },
        {
          title: '产能效率(分钟/套/人)',
          dataIndex: 'efficiency',
          width: 170,
          align: 'center'
        },
        {
          title: '产能(套/时)',
          dataIndex: 'unitCapacity',
          align: 'center'
        }
      ],
      routingList: []
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg
    })
  },
  created () {
    this.getLookupList('MES_OPERATION_TYPE', 'operationTypeList')
    // this.inventOrgValueOnChange(this.inventOrg.length > 0 && this.inventOrg[0].realValue, "yes")
  },
  methods: {
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 工艺路线
    routingIdOnChange (val) {
      this.form.setFieldsValue({
        routingDesc: this.routingList.find(item => val === item.id).routingDesc
      })
    },
    // 加工组织
    inventOrgValueOnChange (val, status) {
      apiBomRoutingHeaderFindList({ organizationCode: val, isStandardRoutingFlag: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.routingList = res
          this.form.setFieldsValue({
            routingId: res[0].id,
            routingDesc: res[0].routingDesc
          })

          status === "yes" && this.handleQuery()
        } else {
          this.routingList = []
          this.form.setFieldsValue({
            routingId: "",
            routingDesc: ""
          })
        }
      })
    },
    /** 查询列表 */
    getList () {
      this.tableLoading = true
      apiBomRoutingHeaderId(this.form.getFieldsValue().routingId).then(res => {
        this.tableData = res.data
        this.tableList = res.data.bomRoutingLineDtoList
        this.tableLoading = false
      })
    },
    // 新增/修改框事件
    handleOk (status, obj) {
      this.form.setFieldsValue({
        inventOrgValue: obj.organizationCode
      })
      apiBomRoutingHeaderFindList({ organizationCode: this.form.getFieldsValue().inventOrgValue, isStandardRoutingFlag: "Y" }).then(res => {
        if (res && res.length > 0) {
          this.routingList = res
          if (status === "edit") {
            this.form.setFieldsValue({
              routingId: obj.id,
              routingDesc: obj.routingDesc
            })
          }
          if (status === "add") {
            this.form.setFieldsValue({
              routingId: this.$getFlagName(res, obj.routingCode, "routingCode", "id") || "",
              routingDesc: this.$getFlagName(res, obj.routingCode, "routingCode", "routingDesc") || ""
            })
          }
          this.handleQuery()
        } else {
          this.routingList = []
          this.form.setFieldsValue({
            routingId: "",
            routingDesc: ""
          })
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      if (!this.form.getFieldsValue().inventOrgValue) {
        this.$message.warning('加工组织不能为空')
        return;
      }
      if (!this.form.getFieldsValue().routingId) {
        this.$message.warning('工艺路线不能为空')
        return;
      }
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      // this.inventOrgValueOnChange(this.inventOrg.length > 0 && this.inventOrg[0].realValue, "yes")
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('bom/bomRoutingHeader/template', {},
      `标准工艺路线导入模板_${new Date().getTime()}.xlsx`)
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = {
        id: this.form.getFieldsValue().routingId,
        organizationCode: this.form.getFieldsValue().inventOrgValue
      }
      this.$refs.download.openModal(params)
      // this.download('bom/bomRoutingHeader/export_line', {
      //   id: this.form.getFieldsValue().routingId,
      //   organizationCode: this.form.getFieldsValue().inventOrgValue
      // }, `标准工艺路线_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
input{
  width: 200px
}
.itemcode{
  /deep/.ant-form-item-children{
    display: flex;
    align-items: center;
  }
}
</style>
